module.exports = __webpack_public_path__ + "static/Lato-SemiboldItalic-d5fa302ed37be6c20a884a70850dba22.ttf";